export default __webpack_public_path__ + "static/media/float icon2.5468273d.png";